// extracted by mini-css-extract-plugin
export var addressFields = "_n8-0";
export var animationContainer = "_n8-1";
export var footer = "_n8-2";
export var lineItems = "_n8-3";
export var modalContent = "_n8-4";
export var orderName = "_n8-5";
export var strong = "_n8-6";
export var warning = "_n8-7";